import { useState } from "react";
import { Controller, FieldPath, type Control } from "react-hook-form";
import makeAnimated from "react-select/animated";
import AsyncSelect from "react-select/async";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import useGetHook from "../../../customHooks/useGetHook";

const animatedComponents = makeAnimated();

interface Props<T> {
  label: string;
  queryKey: string;
  params: {
    [key: string]: any;
  };
  name: FieldPath<T>;
  control: Control<T, any>;
  url: string;
  limit?: number;
  [key: string]: any;
}

const MultiSelectFilter = <T,>({
  label,
  queryKey,
  params,
  name,
  control,
  url,
  limit = 10,
  ...otherProps
}: Props<T>) => {
  const [query, setQuery] = useState("");

  const { data: serverData } = useGetHook({
    queryKey: [queryKey, `${queryKey}-${limit}-${query}`],
    url: url,
    params: {
      limit: limit,
      offset: 0,
      search: query,
      ...params,
    },
  });

  const loadOptions = (
    inputValue: string,
    callback: (options: any) => void
  ) => {
    setQuery(inputValue?.length == 1 ? "" : inputValue);
    setTimeout(() => {
      callback(
        serverData?.map((item: any, index: number) => ({
          label: item?.label,
          value: item?.label,
        }))
      );
    }, 0);
  };

  return (
    <div className={tw`mt-4`}>
      <label htmlFor="">{label}</label>
      <Controller
        control={control}
        name={name}
        defaultValue={null}
        render={({ field, fieldState: { error } }) => (
          <>
            <AsyncSelect
              {...field}
              loadOptions={loadOptions}
              components={animatedComponents}
              closeMenuOnSelect={false}
              isMulti
              styles={{
                control(base, props) {
                  return {
                    ...base,
                    backgroundColor: "#EEF5F4",
                    border:
                      props.menuIsOpen || props.isFocused ? "none" : "none",
                    outline:
                      props.menuIsOpen || props.isFocused
                        ? "none !important"
                        : "none  !important",
                    cursor: "text",
                  };
                },
              }}
              defaultOptions={
                serverData?.map((item: any, index: number) => ({
                  label: item?.label,
                  value: item?.label,
                })) ?? []
              }
            />
            {error && (
              <p className={tw`text-red-500 text-xs py-1`}>{error?.message}</p>
            )}
          </>
        )}
      />
    </div>
  );
};

export default MultiSelectFilter;
